// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".settings-username-input[data-v-45de117c]{padding-left:2.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
